import {FETCH_RATE_CARD, FETCH_RATE_CARD_SUCCESS, FETCH_RATE_CARD_ERROR, UPDATE_RATE_CARD, UPDATE_RATE_CARD_SUCCESS, UPDATE_RATE_CARD_ERROR, RESET_UPDATE_RATE_CARD} from "constants/ActionTypes";

export const fetchRateCard = () => {
  return {
    type: FETCH_RATE_CARD,
  }
};

export const fetchRateCardSuccess = (rateCardList) => {
  return {
    type: FETCH_RATE_CARD_SUCCESS,
    payload: rateCardList,
  }
};

export const fetchRateCardError = (error) => {
  return {
    type: FETCH_RATE_CARD_ERROR,
    payload: error
  }
};

export const updateRateCard = (params) => {
  return {
    type: UPDATE_RATE_CARD,
    params,
  }
};

export const updateRateCardSuccess = (payload) => {
  return {
    type: UPDATE_RATE_CARD_SUCCESS,
    payload,
  }
};

export const updateRateCardError = (error) => {
  return {
    type: UPDATE_RATE_CARD_ERROR,
    payload: error
  }
};

export const resetUpdateRateCard = () => {
  return {
    type: RESET_UPDATE_RATE_CARD,
  }
};
